/**
 * Back-office API
 * In charge of providing data to the back-office frontend apps
 *
 * The version of the OpenAPI document: 1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
/* tslint:disable:no-unused-variable member-ordering */

import { Inject, Injectable, Optional } from '@angular/core';
import {
  HttpClient,
  HttpHeaders,
  HttpParams,
  HttpResponse,
  HttpEvent,
  HttpParameterCodec,
  HttpContext,
} from '@angular/common/http';
import { CustomHttpParameterCodec } from '../encoder';
import { Observable } from 'rxjs';

// @ts-ignore
import { ReportDvirView } from '../model/reportDvirView';
// @ts-ignore
import { ReportEldUnidentifiedView } from '../model/reportEldUnidentifiedView';
// @ts-ignore
import { ReportEldView } from '../model/reportEldView';

// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS } from '../variables';
import { Configuration } from '../configuration';

@Injectable({
  providedIn: 'root',
})
export class ReportsService {
  protected basePath = 'http://localhost';
  public defaultHeaders = new HttpHeaders();
  public configuration = new Configuration();
  public encoder: HttpParameterCodec;

  constructor(
    protected httpClient: HttpClient,
    @Optional() @Inject(BASE_PATH) basePath: string | string[],
    @Optional() configuration: Configuration
  ) {
    if (configuration) {
      this.configuration = configuration;
    }
    if (typeof this.configuration.basePath !== 'string') {
      if (Array.isArray(basePath) && basePath.length > 0) {
        basePath = basePath[0];
      }

      if (typeof basePath !== 'string') {
        basePath = this.basePath;
      }
      this.configuration.basePath = basePath;
    }
    this.encoder = this.configuration.encoder || new CustomHttpParameterCodec();
  }

  // @ts-ignore
  private addToHttpParams(
    httpParams: HttpParams,
    value: any,
    key?: string
  ): HttpParams {
    if (typeof value === 'object' && value instanceof Date === false) {
      httpParams = this.addToHttpParamsRecursive(httpParams, value);
    } else {
      httpParams = this.addToHttpParamsRecursive(httpParams, value, key);
    }
    return httpParams;
  }

  private addToHttpParamsRecursive(
    httpParams: HttpParams,
    value?: any,
    key?: string
  ): HttpParams {
    if (value == null) {
      return httpParams;
    }

    if (typeof value === 'object') {
      if (Array.isArray(value)) {
        (value as any[]).forEach(
          (elem) =>
            (httpParams = this.addToHttpParamsRecursive(httpParams, elem, key))
        );
      } else if (value instanceof Date) {
        if (key != null) {
          httpParams = httpParams.append(
            key,
            (value as Date).toISOString().substr(0, 10)
          );
        } else {
          throw Error('key may not be null if value is Date');
        }
      } else {
        Object.keys(value).forEach(
          (k) =>
            (httpParams = this.addToHttpParamsRecursive(
              httpParams,
              value[k],
              key != null ? `${key}.${k}` : k
            ))
        );
      }
    } else if (key != null) {
      httpParams = httpParams.append(key, value);
    } else {
      throw Error('key may not be null if value is not object or array');
    }
    return httpParams;
  }

  /**
   * Get all dvirs.
   * @param page
   * @param accept
   * @param after
   * @param before
   * @param dvirResourceType
   * @param language
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public reportsControllerFindDvirs(
    page: number,
    accept:
      | 'application/json'
      | 'text/csv'
      | 'application/pdf'
      | 'application/zip',
    after?: string,
    before?: string,
    dvirResourceType?: 'all' | 'driver' | 'vehicle',
    language?: 'en' | 'fr',
    observe?: 'body',
    reportProgress?: boolean,
    options?: { httpHeaderAccept?: 'application/json'; context?: HttpContext }
  ): Observable<ReportDvirView>;
  public reportsControllerFindDvirs(
    page: number,
    accept:
      | 'application/json'
      | 'text/csv'
      | 'application/pdf'
      | 'application/zip',
    after?: string,
    before?: string,
    dvirResourceType?: 'all' | 'driver' | 'vehicle',
    language?: 'en' | 'fr',
    observe?: 'response',
    reportProgress?: boolean,
    options?: { httpHeaderAccept?: 'application/json'; context?: HttpContext }
  ): Observable<HttpResponse<ReportDvirView>>;
  public reportsControllerFindDvirs(
    page: number,
    accept:
      | 'application/json'
      | 'text/csv'
      | 'application/pdf'
      | 'application/zip',
    after?: string,
    before?: string,
    dvirResourceType?: 'all' | 'driver' | 'vehicle',
    language?: 'en' | 'fr',
    observe?: 'events',
    reportProgress?: boolean,
    options?: { httpHeaderAccept?: 'application/json'; context?: HttpContext }
  ): Observable<HttpEvent<ReportDvirView>>;
  public reportsControllerFindDvirs(
    page: number,
    accept:
      | 'application/json'
      | 'text/csv'
      | 'application/pdf'
      | 'application/zip',
    after?: string,
    before?: string,
    dvirResourceType?: 'all' | 'driver' | 'vehicle',
    language?: 'en' | 'fr',
    observe: any = 'body',
    reportProgress: boolean = false,
    options?: { httpHeaderAccept?: 'application/json'; context?: HttpContext }
  ): Observable<any> {
    if (page === null || page === undefined) {
      throw new Error(
        'Required parameter page was null or undefined when calling reportsControllerFindDvirs.'
      );
    }
    if (accept === null || accept === undefined) {
      throw new Error(
        'Required parameter accept was null or undefined when calling reportsControllerFindDvirs.'
      );
    }

    let localVarQueryParameters = new HttpParams({ encoder: this.encoder });
    if (after !== undefined && after !== null) {
      localVarQueryParameters = this.addToHttpParams(
        localVarQueryParameters,
        <any>after,
        'after'
      );
    }
    if (before !== undefined && before !== null) {
      localVarQueryParameters = this.addToHttpParams(
        localVarQueryParameters,
        <any>before,
        'before'
      );
    }
    if (dvirResourceType !== undefined && dvirResourceType !== null) {
      localVarQueryParameters = this.addToHttpParams(
        localVarQueryParameters,
        <any>dvirResourceType,
        'dvirResourceType'
      );
    }
    if (language !== undefined && language !== null) {
      localVarQueryParameters = this.addToHttpParams(
        localVarQueryParameters,
        <any>language,
        'language'
      );
    }
    if (page !== undefined && page !== null) {
      localVarQueryParameters = this.addToHttpParams(
        localVarQueryParameters,
        <any>page,
        'page'
      );
    }
    if (accept !== undefined && accept !== null) {
      localVarQueryParameters = this.addToHttpParams(
        localVarQueryParameters,
        <any>accept,
        'accept'
      );
    }

    let localVarHeaders = this.defaultHeaders;

    let localVarCredential: string | undefined;
    // authentication (bearer) required
    localVarCredential = this.configuration.lookupCredential('bearer');
    if (localVarCredential) {
      localVarHeaders = localVarHeaders.set(
        'Authorization',
        'Bearer ' + localVarCredential
      );
    }

    let localVarHttpHeaderAcceptSelected: string | undefined =
      options && options.httpHeaderAccept;
    if (localVarHttpHeaderAcceptSelected === undefined) {
      // to determine the Accept header
      const httpHeaderAccepts: string[] = ['application/json'];
      localVarHttpHeaderAcceptSelected =
        this.configuration.selectHeaderAccept(httpHeaderAccepts);
    }
    if (localVarHttpHeaderAcceptSelected !== undefined) {
      localVarHeaders = localVarHeaders.set(
        'Accept',
        localVarHttpHeaderAcceptSelected
      );
    }

    let localVarHttpContext: HttpContext | undefined =
      options && options.context;
    if (localVarHttpContext === undefined) {
      localVarHttpContext = new HttpContext();
    }

    let responseType_: 'text' | 'json' | 'blob' = 'json';
    if (localVarHttpHeaderAcceptSelected) {
      if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
        responseType_ = 'text';
      } else if (
        this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)
      ) {
        responseType_ = 'json';
      } else {
        responseType_ = 'blob';
      }
    }

    let localVarPath = `/reports/dvirs`;
    return this.httpClient.request<ReportDvirView>(
      'get',
      `${this.configuration.basePath}${localVarPath}`,
      {
        context: localVarHttpContext,
        params: localVarQueryParameters,
        responseType: <any>responseType_,
        withCredentials: this.configuration.withCredentials,
        headers: localVarHeaders,
        observe: observe,
        reportProgress: reportProgress,
      }
    );
  }

  /**
   * Get all eld reports by driver.
   * @param start
   * @param end
   * @param page
   * @param resourceIds Driver ids or Vehicle ids
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public reportsControllerGetEldReportsByDrivers(
    start: string,
    end: string,
    page: number,
    resourceIds: Array<number>,
    observe?: 'body',
    reportProgress?: boolean,
    options?: { httpHeaderAccept?: 'application/json'; context?: HttpContext }
  ): Observable<ReportEldView>;
  public reportsControllerGetEldReportsByDrivers(
    start: string,
    end: string,
    page: number,
    resourceIds: Array<number>,
    observe?: 'response',
    reportProgress?: boolean,
    options?: { httpHeaderAccept?: 'application/json'; context?: HttpContext }
  ): Observable<HttpResponse<ReportEldView>>;
  public reportsControllerGetEldReportsByDrivers(
    start: string,
    end: string,
    page: number,
    resourceIds: Array<number>,
    observe?: 'events',
    reportProgress?: boolean,
    options?: { httpHeaderAccept?: 'application/json'; context?: HttpContext }
  ): Observable<HttpEvent<ReportEldView>>;
  public reportsControllerGetEldReportsByDrivers(
    start: string,
    end: string,
    page: number,
    resourceIds: Array<number>,
    observe: any = 'body',
    reportProgress: boolean = false,
    options?: { httpHeaderAccept?: 'application/json'; context?: HttpContext }
  ): Observable<any> {
    if (start === null || start === undefined) {
      throw new Error(
        'Required parameter start was null or undefined when calling reportsControllerGetEldReportsByDrivers.'
      );
    }
    if (end === null || end === undefined) {
      throw new Error(
        'Required parameter end was null or undefined when calling reportsControllerGetEldReportsByDrivers.'
      );
    }
    if (page === null || page === undefined) {
      throw new Error(
        'Required parameter page was null or undefined when calling reportsControllerGetEldReportsByDrivers.'
      );
    }
    if (resourceIds === null || resourceIds === undefined) {
      throw new Error(
        'Required parameter resourceIds was null or undefined when calling reportsControllerGetEldReportsByDrivers.'
      );
    }

    let localVarQueryParameters = new HttpParams({ encoder: this.encoder });
    if (start !== undefined && start !== null) {
      localVarQueryParameters = this.addToHttpParams(
        localVarQueryParameters,
        <any>start,
        'start'
      );
    }
    if (end !== undefined && end !== null) {
      localVarQueryParameters = this.addToHttpParams(
        localVarQueryParameters,
        <any>end,
        'end'
      );
    }
    if (page !== undefined && page !== null) {
      localVarQueryParameters = this.addToHttpParams(
        localVarQueryParameters,
        <any>page,
        'page'
      );
    }
    if (resourceIds) {
      resourceIds.forEach((element) => {
        localVarQueryParameters = this.addToHttpParams(
          localVarQueryParameters,
          <any>element,
          'resourceIds'
        );
      });
    }

    let localVarHeaders = this.defaultHeaders;

    let localVarCredential: string | undefined;
    // authentication (bearer) required
    localVarCredential = this.configuration.lookupCredential('bearer');
    if (localVarCredential) {
      localVarHeaders = localVarHeaders.set(
        'Authorization',
        'Bearer ' + localVarCredential
      );
    }

    let localVarHttpHeaderAcceptSelected: string | undefined =
      options && options.httpHeaderAccept;
    if (localVarHttpHeaderAcceptSelected === undefined) {
      // to determine the Accept header
      const httpHeaderAccepts: string[] = ['application/json'];
      localVarHttpHeaderAcceptSelected =
        this.configuration.selectHeaderAccept(httpHeaderAccepts);
    }
    if (localVarHttpHeaderAcceptSelected !== undefined) {
      localVarHeaders = localVarHeaders.set(
        'Accept',
        localVarHttpHeaderAcceptSelected
      );
    }

    let localVarHttpContext: HttpContext | undefined =
      options && options.context;
    if (localVarHttpContext === undefined) {
      localVarHttpContext = new HttpContext();
    }

    let responseType_: 'text' | 'json' | 'blob' = 'json';
    if (localVarHttpHeaderAcceptSelected) {
      if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
        responseType_ = 'text';
      } else if (
        this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)
      ) {
        responseType_ = 'json';
      } else {
        responseType_ = 'blob';
      }
    }

    let localVarPath = `/reports/elds/drivers`;
    return this.httpClient.request<ReportEldView>(
      'get',
      `${this.configuration.basePath}${localVarPath}`,
      {
        context: localVarHttpContext,
        params: localVarQueryParameters,
        responseType: <any>responseType_,
        withCredentials: this.configuration.withCredentials,
        headers: localVarHeaders,
        observe: observe,
        reportProgress: reportProgress,
      }
    );
  }

  /**
   * Get all eld reports by vehicle.
   * @param start
   * @param end
   * @param page
   * @param resourceIds Driver ids or Vehicle ids
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public reportsControllerGetEldReportsByVehicle(
    start: string,
    end: string,
    page: number,
    resourceIds: Array<number>,
    observe?: 'body',
    reportProgress?: boolean,
    options?: { httpHeaderAccept?: 'application/json'; context?: HttpContext }
  ): Observable<ReportEldView>;
  public reportsControllerGetEldReportsByVehicle(
    start: string,
    end: string,
    page: number,
    resourceIds: Array<number>,
    observe?: 'response',
    reportProgress?: boolean,
    options?: { httpHeaderAccept?: 'application/json'; context?: HttpContext }
  ): Observable<HttpResponse<ReportEldView>>;
  public reportsControllerGetEldReportsByVehicle(
    start: string,
    end: string,
    page: number,
    resourceIds: Array<number>,
    observe?: 'events',
    reportProgress?: boolean,
    options?: { httpHeaderAccept?: 'application/json'; context?: HttpContext }
  ): Observable<HttpEvent<ReportEldView>>;
  public reportsControllerGetEldReportsByVehicle(
    start: string,
    end: string,
    page: number,
    resourceIds: Array<number>,
    observe: any = 'body',
    reportProgress: boolean = false,
    options?: { httpHeaderAccept?: 'application/json'; context?: HttpContext }
  ): Observable<any> {
    if (start === null || start === undefined) {
      throw new Error(
        'Required parameter start was null or undefined when calling reportsControllerGetEldReportsByVehicle.'
      );
    }
    if (end === null || end === undefined) {
      throw new Error(
        'Required parameter end was null or undefined when calling reportsControllerGetEldReportsByVehicle.'
      );
    }
    if (page === null || page === undefined) {
      throw new Error(
        'Required parameter page was null or undefined when calling reportsControllerGetEldReportsByVehicle.'
      );
    }
    if (resourceIds === null || resourceIds === undefined) {
      throw new Error(
        'Required parameter resourceIds was null or undefined when calling reportsControllerGetEldReportsByVehicle.'
      );
    }

    let localVarQueryParameters = new HttpParams({ encoder: this.encoder });
    if (start !== undefined && start !== null) {
      localVarQueryParameters = this.addToHttpParams(
        localVarQueryParameters,
        <any>start,
        'start'
      );
    }
    if (end !== undefined && end !== null) {
      localVarQueryParameters = this.addToHttpParams(
        localVarQueryParameters,
        <any>end,
        'end'
      );
    }
    if (page !== undefined && page !== null) {
      localVarQueryParameters = this.addToHttpParams(
        localVarQueryParameters,
        <any>page,
        'page'
      );
    }
    if (resourceIds) {
      resourceIds.forEach((element) => {
        localVarQueryParameters = this.addToHttpParams(
          localVarQueryParameters,
          <any>element,
          'resourceIds'
        );
      });
    }

    let localVarHeaders = this.defaultHeaders;

    let localVarCredential: string | undefined;
    // authentication (bearer) required
    localVarCredential = this.configuration.lookupCredential('bearer');
    if (localVarCredential) {
      localVarHeaders = localVarHeaders.set(
        'Authorization',
        'Bearer ' + localVarCredential
      );
    }

    let localVarHttpHeaderAcceptSelected: string | undefined =
      options && options.httpHeaderAccept;
    if (localVarHttpHeaderAcceptSelected === undefined) {
      // to determine the Accept header
      const httpHeaderAccepts: string[] = ['application/json'];
      localVarHttpHeaderAcceptSelected =
        this.configuration.selectHeaderAccept(httpHeaderAccepts);
    }
    if (localVarHttpHeaderAcceptSelected !== undefined) {
      localVarHeaders = localVarHeaders.set(
        'Accept',
        localVarHttpHeaderAcceptSelected
      );
    }

    let localVarHttpContext: HttpContext | undefined =
      options && options.context;
    if (localVarHttpContext === undefined) {
      localVarHttpContext = new HttpContext();
    }

    let responseType_: 'text' | 'json' | 'blob' = 'json';
    if (localVarHttpHeaderAcceptSelected) {
      if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
        responseType_ = 'text';
      } else if (
        this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)
      ) {
        responseType_ = 'json';
      } else {
        responseType_ = 'blob';
      }
    }

    let localVarPath = `/reports/elds/vehicles`;
    return this.httpClient.request<ReportEldView>(
      'get',
      `${this.configuration.basePath}${localVarPath}`,
      {
        context: localVarHttpContext,
        params: localVarQueryParameters,
        responseType: <any>responseType_,
        withCredentials: this.configuration.withCredentials,
        headers: localVarHeaders,
        observe: observe,
        reportProgress: reportProgress,
      }
    );
  }

  /**
   * Get all unidentified eld reports.
   * @param start
   * @param end
   * @param page
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public reportsControllerGetUnidentifiedEldReports(
    start: string,
    end: string,
    page: number,
    observe?: 'body',
    reportProgress?: boolean,
    options?: { httpHeaderAccept?: 'application/json'; context?: HttpContext }
  ): Observable<ReportEldUnidentifiedView>;
  public reportsControllerGetUnidentifiedEldReports(
    start: string,
    end: string,
    page: number,
    observe?: 'response',
    reportProgress?: boolean,
    options?: { httpHeaderAccept?: 'application/json'; context?: HttpContext }
  ): Observable<HttpResponse<ReportEldUnidentifiedView>>;
  public reportsControllerGetUnidentifiedEldReports(
    start: string,
    end: string,
    page: number,
    observe?: 'events',
    reportProgress?: boolean,
    options?: { httpHeaderAccept?: 'application/json'; context?: HttpContext }
  ): Observable<HttpEvent<ReportEldUnidentifiedView>>;
  public reportsControllerGetUnidentifiedEldReports(
    start: string,
    end: string,
    page: number,
    observe: any = 'body',
    reportProgress: boolean = false,
    options?: { httpHeaderAccept?: 'application/json'; context?: HttpContext }
  ): Observable<any> {
    if (start === null || start === undefined) {
      throw new Error(
        'Required parameter start was null or undefined when calling reportsControllerGetUnidentifiedEldReports.'
      );
    }
    if (end === null || end === undefined) {
      throw new Error(
        'Required parameter end was null or undefined when calling reportsControllerGetUnidentifiedEldReports.'
      );
    }
    if (page === null || page === undefined) {
      throw new Error(
        'Required parameter page was null or undefined when calling reportsControllerGetUnidentifiedEldReports.'
      );
    }

    let localVarQueryParameters = new HttpParams({ encoder: this.encoder });
    if (start !== undefined && start !== null) {
      localVarQueryParameters = this.addToHttpParams(
        localVarQueryParameters,
        <any>start,
        'start'
      );
    }
    if (end !== undefined && end !== null) {
      localVarQueryParameters = this.addToHttpParams(
        localVarQueryParameters,
        <any>end,
        'end'
      );
    }
    if (page !== undefined && page !== null) {
      localVarQueryParameters = this.addToHttpParams(
        localVarQueryParameters,
        <any>page,
        'page'
      );
    }

    let localVarHeaders = this.defaultHeaders;

    let localVarCredential: string | undefined;
    // authentication (bearer) required
    localVarCredential = this.configuration.lookupCredential('bearer');
    if (localVarCredential) {
      localVarHeaders = localVarHeaders.set(
        'Authorization',
        'Bearer ' + localVarCredential
      );
    }

    let localVarHttpHeaderAcceptSelected: string | undefined =
      options && options.httpHeaderAccept;
    if (localVarHttpHeaderAcceptSelected === undefined) {
      // to determine the Accept header
      const httpHeaderAccepts: string[] = ['application/json'];
      localVarHttpHeaderAcceptSelected =
        this.configuration.selectHeaderAccept(httpHeaderAccepts);
    }
    if (localVarHttpHeaderAcceptSelected !== undefined) {
      localVarHeaders = localVarHeaders.set(
        'Accept',
        localVarHttpHeaderAcceptSelected
      );
    }

    let localVarHttpContext: HttpContext | undefined =
      options && options.context;
    if (localVarHttpContext === undefined) {
      localVarHttpContext = new HttpContext();
    }

    let responseType_: 'text' | 'json' | 'blob' = 'json';
    if (localVarHttpHeaderAcceptSelected) {
      if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
        responseType_ = 'text';
      } else if (
        this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)
      ) {
        responseType_ = 'json';
      } else {
        responseType_ = 'blob';
      }
    }

    let localVarPath = `/reports/elds/unidentified`;
    return this.httpClient.request<ReportEldUnidentifiedView>(
      'get',
      `${this.configuration.basePath}${localVarPath}`,
      {
        context: localVarHttpContext,
        params: localVarQueryParameters,
        responseType: <any>responseType_,
        withCredentials: this.configuration.withCredentials,
        headers: localVarHeaders,
        observe: observe,
        reportProgress: reportProgress,
      }
    );
  }
}
